import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { FormikForm } from "components/FormikForm/FormikForm";
import { resolutionDescriptionSchema } from "formValidations/ticketSchema";

type ResolveTicketModalProps = {
  isOpen: boolean;
  close: () => void;
  onConfirm: (description: string) => void;
  isLoading?: boolean;
};

type ResolveTicketFormValues = {
  description: string;
};

const RESOLVE_TICKET_INITIAL_VALUES: ResolveTicketFormValues = {
  description: "",
};

export const ResolveTicketModal = ({
  isOpen,
  close,
  onConfirm,
  isLoading = false,
}: ResolveTicketModalProps) => {
  const handleSubmit = ({ description }: ResolveTicketFormValues) => {
    onConfirm(description);
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content useCustomOverlay>
        <Modal.Header>
          <Modal.Title>Resolve Ticket</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <FormikForm<ResolveTicketFormValues>
          initialValues={RESOLVE_TICKET_INITIAL_VALUES}
          validationSchema={resolutionDescriptionSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <>
              <Modal.Body>
                <TextArea
                  required
                  block
                  label="Description"
                  name="description"
                  placeholder="Add context on how this ticket was resolved"
                />
              </Modal.Body>
              <Modal.FooterButtonGroup>
                <Button
                  type="button"
                  customType="secondary"
                  onClick={close}
                  disabled={isLoading || isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  customType="primary"
                  isLoading={isLoading || isSubmitting}
                  disabled={isLoading || isSubmitting}
                >
                  Resolve
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
